var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_c('span',[_c('div',{staticClass:"circle",style:(`background: ${_vm.color};`)}),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }